
//sub categories where line breaks needed to be added in specific position
export const lineBreakSubCategories = [
  "Enable Team Learning & Improvement",
  "Seek And Act On Feedback",
  "Learn And Adapt To Cultural Contexts",
  "Drive High Performance & Capacity",
  "Understand business interlinkages",
    "Adopt enterprise-wide mindset",
    "Accept Responsibility"

];

export const CHART_DATA = [
  {
      "totalSubCategory": 15,
      "radarChartData": [
          {
              "category": "Self-Awareness",
              "subCategory": "Make self- improvements",
              "subCategoryColumnScore": 4.5,
              "selfAverageScore": 3.5,
              "benchmarkScore": 0
          },
          {
              "category": "Self-Awareness",
              "subCategory": "Enhance self-awareness",
              "subCategoryColumnScore": 4.44,
              "selfAverageScore": 4,
              "benchmarkScore": 0
          },
          {
              "category": "Self-Awareness",
              "subCategory": "Practice courage & resilience",
              "subCategoryColumnScore": 4.75,
              "selfAverageScore": 4,
              "benchmarkScore": 0
          },
          {
              "category": "Coaching",
              "subCategory": "Optimize Talent Potential",
              "subCategoryColumnScore": 2.3,
              "selfAverageScore": 5.33,
              "benchmarkScore": 0
          },
          {
              "category": "Coaching",
              "subCategory": "Increase Performance & Engagement",
              "subCategoryColumnScore": 3.39,
              "selfAverageScore": 5.67,
              "benchmarkScore": 0
          },
          {
              "category": "Coaching",
              "subCategory": "Create Higher  Scale & Capacity",
              "subCategoryColumnScore": 3.42,
              "selfAverageScore": 5.33,
              "benchmarkScore": 0
          },
          {
              "category": "Collaboration",
              "subCategory": "Collaborate across boundaries",
              "subCategoryColumnScore": 3.54,
              "selfAverageScore": 2.86,
              "benchmarkScore": 0
          },
          {
              "category": "Collaboration",
              "subCategory": "Understand business interlinkages",
              "subCategoryColumnScore": 4.04,
              "selfAverageScore": 4,
              "benchmarkScore": 0
          },
          {
              "category": "Collaboration",
              "subCategory": "Optimize Team Learning & Improvement",
              "subCategoryColumnScore": 3.17,
              "selfAverageScore": 5,
              "benchmarkScore": 0
          },
          {
              "category": "Collaboration",
              "subCategory": "Adopt enterprise-wide mindset",
              "subCategoryColumnScore": 3.42,
              "selfAverageScore": 5,
              "benchmarkScore": 0
          },
          {
              "category": "Culture of Inclusion",
              "subCategory": "Show cultural intelligence",
              "subCategoryColumnScore": 3.58,
              "selfAverageScore": 6,
              "benchmarkScore": 0
          },
          {
              "category": "Culture of Inclusion",
              "subCategory": "Enable psychological safety",
              "subCategoryColumnScore": 3.25,
              "selfAverageScore": 1,
              "benchmarkScore": 0
          },
          {
              "category": "Culture of Inclusion",
              "subCategory": "Build diverse teams",
              "subCategoryColumnScore": 4,
              "selfAverageScore": 4,
              "benchmarkScore": 0
          },
          {
              "category": "Team Development",
              "subCategory": "Realize Power of the Team",
              "subCategoryColumnScore": 3.92,
              "selfAverageScore": 3.5,
              "benchmarkScore": 0
          },
          {
              "category": "Team Development",
              "subCategory": "Increase Clarity & Accountability",
              "subCategoryColumnScore": 3.55,
              "selfAverageScore": 2.67,
              "benchmarkScore": 0
          },
          {
              "category": "Team Development",
              "subCategory": "Optimize Team Learning & Improvement",
              "subCategoryColumnScore": 4.31,
              "selfAverageScore": 5,
              "benchmarkScore": 0
          }
      ],
      "donutChartData": [
          {
              "category": "Self-Awareness",
              "numberOfSubCategory": 3
          },
          {
              "category": "Coaching",
              "numberOfSubCategory": 3
          },
          {
              "category": "Collaboration",
              "numberOfSubCategory": 4
          },
          {
              "category": "Culture of Inclusion",
              "numberOfSubCategory": 3
          },
          {
              "category": "Team Development",
              "numberOfSubCategory": 3
          }
      ]
  }
]
